<template>
  <v-card v-resize="onResize" class="v-card--flat deliveryContainer">
    <v-flex xs12>
      <mapOverview :properties="mapOverviewProps"></mapOverview>
    </v-flex>
    <v-card class="deliveryContent v-card--flat">
      <v-layout justify-space-between row>
        <v-flex xs4>
          <v-card>
            <v-card class="filterTitle" :style="`border-bottom: 0.3em solid ${$vuetify.theme.primary};`">
              <v-layout justify-center align-center row fill-height>
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('DELIVERY_CONFIG')}}</h3>
              </v-layout>
            </v-card>
            <v-form>
              <v-container>
                <v-flex xs12>
                  <v-layout justify-space-between row wrap>
                    <v-flex xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('DELIVERY')}}</h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="deliveryPartner"
                        :label="$translate('DELIVERY_PARTNER')"
                        append-icon="local_shipping"
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="filterSubTitles" xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('ADDRESS')}}</h2>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="street"
                        :label="$translate('STREET')"
                        append-icon="house"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="houseNumber"
                        :label="$translate('HOUSE_NUMBER')"
                        type="number"
                        append-icon="looks_5"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="city"
                        :label="$translate('CITY')"
                        append-icon="location_city"
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="filterSubTitles" xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('TIME/DATEINFO')}}</h2>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="startTime"
                        :label="$translate('CALENDAR_EVENT_STARTTIME')"
                        type="time"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        @input="checkAllInputs()"
                        v-model="endTime"
                        :label="$translate('CALENDAR_EVENT_ENDTIME')"
                        type="time"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-menu
                        ref="menu1"
                        :close-on-content-click="true"
                        v-model="menu1"
                        :nudge-right="40"
                        :return-value.sync="startDate"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="computedDateFormattedStartDate"
                          :label="$translate('STARTDATE')"
                          append-icon="event"
                          readonly
                          ref="eventForm"
                        ></v-text-field>
                        <v-date-picker
                          :min="nowDate"
                          first-day-of-week="1"
                          color="primary"
                          @change="checkAllInputs()"
                          v-model="startDate"
                          @input="$refs.menu1.save(startDate)"
                          no-title
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex xs5>
                      <v-menu
                        ref="menu2"
                        :close-on-content-click="true"
                        v-model="menu2"
                        :nudge-right="40"
                        :return-value.sync="endDate"
                        lazy
                        :disabled="startDate === ''"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          :disabled="startDate === ''"
                          slot="activator"
                          v-model="computedDateFormattedEndDate"
                          :label="$translate('ENDDATE')"
                          append-icon="event"
                          readonly
                          ref="eventForm"
                        ></v-text-field>
                        <v-date-picker
                          :min="startDate"
                          :disabled="startDate === ''"
                          first-day-of-week="1"
                          color="primary"
                          @change="checkAllInputs()"
                          v-model="endDate"
                          @input="$refs.menu2.save(endDate)"
                          no-title
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex class="filterSubTitles" xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('TRANSPORT')}}</h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :item-text="getIconOrTextForSelect(transportType.transport, 'Text')"
                        @change="checkAllInputs()"
                        v-model="transportType"
                        :items="transportItems"
                        return-object
                        :label="$translate('LINDA_TRANSPORT_TYPE')"
                      >
                        <template slot="selection" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          {{ getIconOrTextForSelect(transportType.transport, 'Text') }}
                        </template>
                        <template
                          slot="item"
                          slot-scope="data"
                        >
                          <template>
                            <v-list-tile-content>
                              <v-layout row align-center justify-space-between style="width: 100% !important;">
                                <v-list-tile-title v-html="getIconOrTextForSelect(data.item.transport, 'Text')"></v-list-tile-title>
                                <div class="text-xs-center">
                                  <v-icon>{{getIconOrTextForSelect(data.item.transport, 'Icon')}}</v-icon>
                                </div>
                              </v-layout>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        @input="checkAllInputs()"
                        :label="$translate('EVENT_CAP_SHORT')"
                        type="number"
                        v-model="capacity"
                        append-icon="ti-package"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-layout row justify-center>
                        <v-btn round color="secondary" @click="addDelivererToList()">
                          {{$translate('ADD_DELIVERY_PERSON')}}
                        </v-btn>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <div>
                        <template v-for="(item, index) in allDeliveryPersons">
                          <v-chip color="secondary">
                            {{item}}
                            <v-icon @click="removeChipFromArray(index)" small style="margin-left: 0.5em; color: #555 !important;">cancel</v-icon>
                          </v-chip>
                        </template>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-container>
              <v-flex xs12 class="filterSubTitles">
                <v-layout justify-center row>
                  <v-btn :disabled="disableGenerateButton" round color="primary" @click="getDeliveryRoutes()">
                    {{$translate('GENERATE_ROUTE')}}
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-form>
            <v-progress-linear
              v-if="loading"
              :indeterminate="true"
              color="primary"
            ></v-progress-linear>
          </v-card>
        </v-flex>
        <v-flex xs7>
          <v-flex xs12 v-if="carSection">
            <v-layout column>
              <v-flex xs12>
                <v-layout row wrap justify-center>
                  <template v-for="(item, index) in deliverData">
                    <v-card :style="`width: ${cardWidth}; background-color: ${setIndexOfSelectedTab == index ? $vuetify.theme.primary : 'white'}`"
                            class="toggleDeliverHeader"
                            @click="getSelectedTab(index, item)">
                      <v-layout justify-center align-center column fill-height>
                        <v-icon :color="setIndexOfSelectedTab == index ? 'white' : $vuetify.theme.primary">{{index != 'Dropped' ? deliverIcon: 'ti-dropbox-alt'}}</v-icon>
                        <h4 :style="`color: ${setIndexOfSelectedTab == index ? 'white' : $vuetify.theme.primary};`" style="text-align: center;"><b>{{ index != 'Dropped' ?  $translate('DELIVERER') + ' ' + (Number(index) + 1) : $translate('DROPPED')}}</b></h4>
                      </v-layout>
                    </v-card>
                  </template>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="setIndexOfSelectedTab !== 'Dropped'">
                <v-flex v-if="!noOrders">
                  <template v-for="(item, index) in visibleOrders">
                    <v-flex xs12 class="pickupOrDeliveryCard">
                      <v-card>
                        <v-layout row>
                          <v-flex :style="`background-color: ${item.Action == 'PickUp' ? $vuetify.theme.primary : $vuetify.theme.secondary}`" xs2>
                            <v-layout column justify-center align-center fill-height>
                              <v-icon dark medium>{{item.Action === 'PickUp' ? 'ti-package' : 'house'}}</v-icon>
                            </v-layout>
                          </v-flex>
                          <v-flex xs10 class="deliverDataBlock">
                            <p class="noMarginForP"><b>{{$translate('NAME')}}: </b>{{item.Name}}</p>
                            <p class="noMarginForP"><b>{{$translate('ADDRESS')}}: </b>{{item.StreetName}} {{item.Number}} {{item.City}}</p>
                            <p class="noMarginForP"><b>{{$translate('ORDERID')}}: </b>{{item.OrderId}}</p>
                            <p class="noMarginForP"><b>{{$translate('DELIVERYNR')}}: </b>{{item.DeliveryNr}}</p>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </template>
                  <v-pagination
                    v-model="page"
                    :length="Math.ceil(selectedTab.Orders.length/perPage)"
                  ></v-pagination>
                  <v-layout row justify-end>
                    <v-btn
                      round
                      @click="getPDFForDeliver(deliverData)"
                      color="secondary"
                    >{{$translate('ORDER_DOWNLOAD')}} PDF</v-btn>
                  </v-layout>
                </v-flex>
                <v-card style="height: 15em;" v-else>
                  <v-layout column align-center justify-center fill-height>
                    <v-icon color="primary" medium>ti-dropbox-alt</v-icon>
                    <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('ORDER_NO_ORDERS')}}</h1>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 v-else>
                <v-flex v-if="!noOrders">
                  <template v-for="(item, index) in selectedTab">
                    <v-flex xs12 class="pickupOrDeliveryCard">
                      <v-card>
                        <v-layout row>
                          <v-flex :style="`background-color: ${$vuetify.theme.secondary}`" xs2>
                            <v-layout column justify-center align-center fill-height>
                              <v-icon dark medium>ti-dropbox-alt</v-icon>
                            </v-layout>
                          </v-flex>
                          <v-flex xs10 class="droppedDataBlock">
                            <p class="noMarginForP"><b>{{$translate('ORDERID')}}: </b>{{item.OrderId}}</p>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </template>
                </v-flex>
                <v-card style="height: 15em;" v-else>
                  <v-layout column align-center justify-center fill-height>
                    <v-icon color="primary" medium>ti-dropbox-alt</v-icon>
                    <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('NOTHING_DROPPED')}}</h1>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else>
            <v-layout column justify-center align-center fill-height>
              <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('START_CONFIGURE')}}</h1>
              <v-icon id="settingsWheel" color="primary" x-large>settings</v-icon>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-card>
</template>
<script>

  import MapOverview from "@/components/Map_Overview";
  import * as dssRequest from "../api/dssRequest";
  import {store} from "../store";
  import OperationalScreen_MapQuadrant from "./OperationalScreen/OperationalScreen_MapQuadrant";
  import _ from "lodash";

  export default {
    name: "DeliveryRouteGenerator",
    data() {
      return {
        //wheel
        rotateWheelVar: '',
        rotation: 0,
        //card info
        carSection: false,
        deliverIcon: '',
        deliverAmount: '',
        deliverData: {},
        selectedTab: {},
        setIndexOfSelectedTab: 0,
        cardWidth: '',
        noOrders: false,

        //inputs
        noLocationFound: false,
        disableGenerateButton: true,
        allDeliveryPersons: [],
        nowDate: new Date().toISOString().slice(0,10),
        cardAmount: 1,
        menu1: false,
        menu2: false,
        startDate: '',
        endDate: '',
        street: '',
        city: '',
        longitude: '',
        latitude: '',
        houseNumber: '',
        deliveryPartner: '',
        startTime: '',
        endTime: '',
        transportType: '',
        capacity: '',
        transportItems: [
          {transport: 'Car'}, {transport: 'Bicycle'}, {transport: 'Walking'}],
        loading: false,
        //map
        deliveryRouteColors: [
          '#e6194b', '#3cb44b', '#ffe119',
          '#4363d8', '#f58231', '#911eb4',
          '#46f0f0', '#f032e6', '#bcf60c',
          '#fabebe', '#008080', '#e6beff',
          '#9a6324', '#fffac8', '#800000',
          '#aaffc3', '#808000', '#ffd8b1',
          '#000075', '#808080', '#000000',
        ],
        mapOverviewProps: {
          height: "height: 25em;",
          showFilterMenu: true,
          showThingsOnMap: false,
          callingOnDRG: true,
        },
        //pagination
        page: 1,
        perPage: 6,
      };
    },
    watch: {
      'startDate' : function(newV, oldV){
        if(newV !== oldV){
          this.endDate = '';
        }
      }
    },
    components: {
      OperationalScreen_MapQuadrant,
      MapOverview
    },
    computed: {
      computedDateFormattedStartDate() {
        return this.formatDate(this.startDate);
      },
      computedDateFormattedEndDate() {
        return this.formatDate(this.endDate);
      },
      visibleOrders() {
        return this.selectedTab.Orders.slice((this.page - 1)* this.perPage, this.page* this.perPage)

      }
    },
    beforeDestroy() {
      this.rotateWheelVar = '';
      this.$store.commit('setAllDelivers', {});
    },
    mounted() {
      if(this.$store.getters["auth/userLevel"] !== 6){
        window.EventBus.fire("goToHome",{});
      }
      // if(this.rotateWheelVar === ''){
      //   this.rotateWheelVar = setInterval(this.rotateWheel, 10);
      // }
    },
    methods: {
      // rotateWheel(){
      //   this.rotation = this.rotation +1;
      //   if (document.getElementById('settingsWheel').hasOwnProperty('style')) {
      //     document.getElementById('settingsWheel').style.transform = 'rotate(' +this.rotation +'deg)';
      //   }
      // },
      time_convert(num){
        let hours = Math.floor(num / 60);
        let minutes = num % 60;
        if(minutes.toString().length === 1){
          minutes = '0' + minutes;
        }
        return hours + ":" + minutes;
      },
      checkAllInputs(){
        //if everthing is filled in (not disabled)
        if(this.deliveryPartner !== '' &&
          this.street !== '' &&
          this.city !== '' &&
          this.houseNumber !== '' &&
          this.startTime !== '' &&
          this.endTime !== '' &&
          this.startDate !== '' &&
          this.endDate !== '' &&
          this.transportType !== '' &&
          this.allDeliveryPersons.length > 0){
          //check if endtime is not smaller than starttime when dates are equal
          if(this.endDate === this.startDate && this.endTime.split(':') <= this.startTime.split(':')){
            this.disableGenerateButton = true;
          }
          else {
            this.disableGenerateButton = false;
          }
        }
        //if there is something not correct (disabled)
        else {
          this.disableGenerateButton = true;
        }
      },
      removeChipFromArray(index){
        this.allDeliveryPersons.splice(index, 1);
        this.checkAllInputs();
      },
      getSelectedTab(index, item){
        this.page = 1;
        if(index !== 'Dropped'){
          if(_.isEmpty(item.Orders)) this.noOrders = true;
          else {
            this.noOrders = false;
            item.Orders = Object.keys(item.Orders).map(key => {
              return item.Orders[key];
            })
          }
        }
        else {
          this.noOrders = _.isEmpty(item);
        }
        this.setIndexOfSelectedTab = index;
        this.selectedTab = item;
      },
      getIconOrTextForSelect(transportType, type){
        if(type === 'Text'){
          switch (transportType) {
            case 'Car':
              return this.$translate('CAR');
              break;
            case 'Bicycle':
              return this.$translate('BICYCLE');
              break;
            case 'Walking':
              return this.$translate('WALKING');
              break;
          }
        }
        else if(type === 'Icon'){
          switch (transportType) {
            case 'Car':
              return 'directions_car';
              break;
            case 'Bicycle':
              return 'pedal_bike';
              break;
            case 'Walking':
              return 'directions_walk';
              break;
          }
        }
      },
      getIconForDeliverTabs(){
        switch (this.transportType) {
          case 'Car':
            this.deliverIcon = 'directions_car';
            break;
          case 'Bicycle':
            this.deliverIcon = 'pedal_bike';
            break;
          case 'Walking':
            this.deliverIcon = 'directions_walk';
            break;
        }
      },
      addDelivererToList(){
        if(this.capacity > 0) {
          this.allDeliveryPersons.push(Number(this.capacity));
        }
        this.checkAllInputs();
      },
      getWithForDeliverTabs(){
        this.cardWidth = (100 / (this.allDeliveryPersons.length + 1)) + '%';
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      },
      getDeliveryRoutes(){
        this.getLongAndLat();
        if(this.noLocationFound){
          // window.EventBus.fire('triggerGenericErrorDialog', 'LOCATION_NOT_FOUND');
          this.deliverData = {};
          this.setIndexOfSelectedTab = 0;
          this.carSection = false;
          return;
        }
        let delivers = Object.assign({}, this.allDeliveryPersons);

        let payload = {
          DeliveryPartner: this.deliveryPartner,
          StartDate: this.computedDateFormattedStartDate,
          EndDate: this.computedDateFormattedEndDate,
          Latitude: Number(this.latitude),
          Longitude: Number(this.longitude),
          StartTime: this.startTime,
          EndTime: this.endTime,
          TransportMode: this.transportType.transport,
          Capacities: delivers,
          AllowDropOrders: false,
        }
        this.disableGenerateButton = true;
        this.loading = true;
        dssRequest.doRequest(
          response => {
            console.log("the call for getDeliveryRoutes was successful", response);
            this.deliverData = response.data;
            this.showDeliveryRoutes(response.data);
            this.setIndexOfSelectedTab = 0;
            this.carSection = true;
            this.getSelectedTab(0, this.deliverData[0])
            this.getIconForDeliverTabs();
            this.getWithForDeliverTabs();
            this.disableGenerateButton = false;
            this.rotateWheelVar = '';
            this.loading = false;
            let arrayWithDelivers = []
            for(let [index, item] of Object.entries(this.deliverData)){
              if(index !== 'Dropped'){
                for(let [innerIndex, innerItem] of Object.entries(item.Orders)){
                  innerItem.Deliver = index;
                  arrayWithDelivers.push(innerItem)
                }
                item.TourInfo.Deliver = index;
                arrayWithDelivers.push(item.TourInfo)
              }
            }
            this.$store.commit('setDeliverMarkers', arrayWithDelivers);
            window.EventBus.fire("showDeliveryRouteMarkers", this.$store.getters.getDeliverMarkers);
          },
          error => {
            console.log("the call for getDeliveryRoutes was not successful", error);
            if(error.data.ErrorMsg === 'E_ROUTE_002'){
              // window.EventBus.fire(
              //   "triggerGenericErrorDialog",
              //   error.data.ErrorMsg);
            }
            this.disableGenerateButton = false;
            this.loading = false;
          },
          "getDeliveryRoutes",
          this.$store.getters.getCurrentAccountId + '_Solver',
          payload,
          600000,
          false
        );
      },
      showDeliveryRoutes(deliverData) {
        let deliveryRouteData = [];
        let self = this;
        deliverData = Object.keys(deliverData).map(key => {
          return deliverData[key];
        });
        // Object.keys(deliverData).forEach(function(key) {
          // deliveryRouteData.push({
          //   path: deliverData[key].TourInfo.DataFieldTable.Path,
          //   stops: deliverData[key].TourInfo.DataFieldTable.Waypoints,
          //   color: self.deliveryRouteColors[key]
          // })
        setTimeout(()=> {
          for (let i = 0; i < deliverData.length; i++) {
            if(!_.isEmpty(deliverData[i])){
              deliveryRouteData.push({
                path: deliverData[i].TourInfo.DataFieldTable.Path,
                stops: deliverData[i].TourInfo.DataFieldTable.Waypoints,
                color: self.deliveryRouteColors[i],
                selected: true,
                totalTime: this.time_convert(deliverData[i].TravelTime)
              });
            }
          }
        }, 10);
        setTimeout(()=> {
          this.$store.commit('setAllDelivers', deliveryRouteData);
          window.EventBus.fire("showDeliveryRoute", this.$store.getters.getAllDelivers);
        }, 20);
        setTimeout(()=> {
          let coordinate = [Number(deliverData[0].TourInfo.Longitude), Number(deliverData[0].TourInfo.Latitude)];
          window.EventBus.fire("showOnMap", coordinate);
        }, 300);
      },
      onResize() {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        this.carouselHeight = 8.1 * window.innerHeight;
      },
      getLongAndLat(){
        let json_obj = JSON.parse(this.Get('https://nominatim.openstreetmap.org/search?q=' + this.houseNumber + '+' + this.street + ',+' + this.city + '&format=json&polygon=1&addressdetails=1'));
        if(_.isEmpty(json_obj)) this.noLocationFound = true;
        else {
          this.noLocationFound = false;
          this.latitude = json_obj[0].lat;
          this.longitude = json_obj[0].lon;
        }
      },
      getPDFForDeliver(order){
        // to download the pdf
        const source = "data:application/pdf;base64," + order[this.setIndexOfSelectedTab].RoutePdf;
        const downloadLink = document.createElement("a");
        const fileName = "route_Driver"+ (this.setIndexOfSelectedTab + 1) + ".pdf";
        downloadLink.href = source;
        downloadLink.download = fileName;
        downloadLink.click();

        //to open the pdf in new window
        let pdfWindow = window.open('')
        setTimeout(() => {
          pdfWindow.document.write(
            "<iframe width='100%' name='text' height='100%' src='data:application/pdf;base64, " +
            encodeURI(order[this.setIndexOfSelectedTab].RoutePdf) + "'></iframe>")
          pdfWindow.document.title = fileName;
        }, 0);
      },
      Get(url){
        let Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET",url,false);
        Httpreq.send(null);
        return Httpreq.responseText;
      },
    }
  };
</script>

<style scoped lang="scss">
  .deliveryContainer {
    margin-top: 2.5em !important;
    margin-left: -3.4em;
    margin-right: -3.4em;
    margin-bottom: 2em;
    padding-bottom: 4em;
    min-height: 60em;
    background-color: white;
  }
  .deliveryContent {
    margin-top: 1em !important;
    max-width: 1200px;
    margin: 0 auto;
  }
  .filterSubTitles {
    margin-top: 2em;
  }
  .filterTitle {
    height: 5em;
    width: 100%;
  }
  .toggleDeliverHeader {
    height: 5em;
    cursor: pointer;
  }
  .pickupOrDeliveryCard {
    margin: 1em 0;
  }
  .noMarginForP {
    margin: 0 !important;
  }
  .deliverDataBlock {
    padding: 1em;
  }
  .droppedDataBlock {
    padding: 2em;
  }
</style>
